import { Environment } from '../app/models/app-config';

export const environment: Environment = {
  production: false,
  MAX_MESSAGE_LENGTH: 1600,
  MAX_MESSAGE_LENGTH_ERROR: 'This messsage has exceeded the maximum character limit and has been truncated.',
  ALLOWED_MESSAGE_ORIGINS: 'https://bardavonhealth--qa.sandbox.my.salesforce.com',
  // TODO: Implement SET_SMS_AVAILABILITY as a REST API endpoint for non-iframe consumers
  ALLOWED_MESSAGE_TYPES: 'SMS_SF_DATA,SET_SMS_AVAILABILITY',
  messagingApi: 'messaging-api.dev.bardavon.net',
  messagingPhone: '+16507302704',
  idp: {
    authUrl: 'https://services-api.dev.aws.bardavon.net/authorize',
    jwtUrl: 'https://services-api.dev.aws.bardavon.net/jwt/',
    clientId: '920939',
    redirectUri: 'https://messaging-ui.dev.bardavon.net/callback',
    scope: 'openid profile email employee',
  }
};
